import styled from "styled-components";

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;